import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { content } from "./data/content";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Values } from "./components/Values";
import { VisionMission } from "./components/VisionMission";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  const [lang, setLang] = useState("fr");
  const t = content[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-aa-green min-h-screen">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#11261B",
            color: "#E7DCC0",
            border: "1px solid rgba(212,175,55,0.4)",
            borderRadius: "0",
          },
        }}
      />
      <Navbar t={t} lang={lang} setLang={setLang} />
      <main>
        <Hero t={t} />
        <About t={t} />
        <Services t={t} />
        <Values t={t} />
        <VisionMission t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
